import { fetchData } from "./fetchData";

const BASE_URL = '/api/v1/business-units';

const getAllBusinessUnits = function () {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/', 'get')
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch business units at this moment.'
        });
      })
  })
}

const getBusinessUnitRequests = function (status) {
  return new Promise((resolve, reject) => {
    const query = status ? { status } : {};
    fetchData(BASE_URL + '/requests', 'get', {}, query)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch business unit requests at this moment.'
        });
      })
  })
}

const getRequestHistory = function (requestId) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/requests/' + requestId + '/history', 'get')
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to fetch request history at this moment.'
        });
      })
  })
}

const createBusinessUnitRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/create', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to create business unit request at this moment.'
        });
      })
  })
}

const updateBusinessUnitRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/update', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to update business unit request at this moment.'
        });
      })
  })
}

const approveBusinessUnitRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/approve', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to approve business unit request at this moment.'
        });
      })
  })
}

const rejectBusinessUnitRequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/reject', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to reject business unit request at this moment.'
        });
      })
  })
}

const editPendingBURequest = function (data) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/edit', 'post', data)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to edit pending request at this moment.'
        });
      })
  })
}

const getPendingRequestForBU = function (params) {
  return new Promise((resolve, reject) => {
    fetchData(BASE_URL + '/request/pending', 'get', {}, params)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject({
          message: 'Unable to check pending request at this moment.'
        });
      })
  })
}

export {
  getAllBusinessUnits,
  getBusinessUnitRequests,
  getRequestHistory,
  createBusinessUnitRequest,
  updateBusinessUnitRequest,
  editPendingBURequest,
  getPendingRequestForBU,
  approveBusinessUnitRequest,
  rejectBusinessUnitRequest
};



// WEBPACK FOOTER //
// ./src/utils/BusinessUnitApiUtils.js